import api from '@/apis/fr/managementLayoutReportAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('ManagementLayoutReport', api);

const state = {
  ...crud.state,
  _config: {
    table: 'rp_design',
    field: {
      key: 'rp_design_id',
      name: 'report_name'
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
